var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-dependency-injection";
import { BindingSignaler } from "aurelia-templating-resources";
import { DialogClientService } from "../../../services/basics/dialog-client.service";
import { bindable } from "aurelia-framework";
import { computedFrom } from "aurelia-framework";
import { IFramePostMessages } from "../../../models/modules/lotteryplatform-client.models";
import { Router } from "aurelia-router";
import { TokenClient } from "../../../services/authentication/token-client.service";
var DialogHost = /** @class */ (function () {
    function DialogHost(bindingSignaler, dialogClient, router, tokenClient) {
        var _this = this;
        this.bindingSignaler = bindingSignaler;
        this.dialogClient = dialogClient;
        this.router = router;
        this.tokenClient = tokenClient;
        this.dialogs = [];
        this.key = "default";
        this.onEsc = function (event) {
            if (!_this.hideOnOutsideClick)
                return;
            if (event.key === "Escape") {
                _this.hideModal();
            }
        };
        this.showDialogueCallback = function (view, model, showCloseButton, fullscreen, hideOnOutsideClick) {
            _this.showCloseButton = showCloseButton;
            _this.hideOnOutsideClick = hideOnOutsideClick;
            var onElementSet = function (element) {
                var animStarted = function () {
                    element.removeEventListener("animationend", animStarted, false);
                    element.classList.remove('au-enter-active');
                };
                element.classList.add('au-enter-active');
                element.addEventListener("animationend", animStarted, false);
            };
            _this.dialogs.push(new DialogItem(view, model, onElementSet, fullscreen, hideOnOutsideClick));
            _this.bindingSignaler.signal("update-class-dialog");
            var routerHeight = $(".router-view")[0].clientHeight;
            var navHeight = $(".common-navigation-menu")[0] ? $(".common-navigation-menu")[0].clientHeight : 0;
            var totalHeight = navHeight + routerHeight;
            if (totalHeight < _this.height) {
                _this.sendHeightToClient(_this.height + "px", false);
            }
        };
        this.hideDialogueCallback = function () {
            if (_this.dialogs.length > 0) {
                var last = _this.dialogs[_this.dialogs.length - 1].element;
                last.classList.add('au-leave-active');
                var animEnded = function () {
                    _this.dialogs.pop();
                };
                last.addEventListener("animationend", animEnded, false);
                //For mobile and tablets hide the keyboard to avoid an issue with ios that keeps the keyboard opened
                if (document.activeElement) {
                    document.activeElement.blur();
                }
                var routerHeight = $(".router-view")[0].clientHeight;
                var navHeight = $(".common-navigation-menu")[0] ? $(".common-navigation-menu")[0].clientHeight : 0;
                var totalHeight = navHeight + routerHeight;
                _this.sendHeightToClient(totalHeight + "px", false);
            }
        };
    }
    DialogHost.prototype.getComponentFromDialogView = function (dialog) {
        var arr = dialog.view ? dialog.view.split("/") : [];
        return arr[arr.length - 1];
    };
    DialogHost.prototype.bind = function () {
        this.dialogClient.subscribeShow(this.showDialogueCallback, this.key);
        this.dialogClient.subscribeHide(this.hideDialogueCallback, this.key);
        document.addEventListener('keydown', this.onEsc);
    };
    DialogHost.prototype.unbind = function () {
        this.dialogClient.unSubscribeShow(this.showDialogueCallback, this.key);
        this.dialogClient.unSubscribeHide(this.hideDialogueCallback, this.key);
        document.removeEventListener('keydown', this.onEsc);
    };
    DialogHost.prototype.hideModal = function (force) {
        if (force === void 0) { force = false; }
        this.dialogClient.hide(force, this.key);
    };
    DialogHost.prototype.sendHeightToClient = function (num, scrollTop) {
        try {
            if (this.tokenClient.isOverlay)
                return;
            window.parent.postMessage({
                event: IFramePostMessages.onIFrameHeightChange,
                detail: {
                    height: num,
                    scrollTop: scrollTop,
                    page: this.getCurrentRoute()
                }
            }, "*");
        }
        catch (e) {
            console.log("failed to send height to client: " + e);
        }
    };
    DialogHost.prototype.getCurrentRoute = function () {
        return this.router.currentInstruction && this.router.currentInstruction.config ? this.router.currentInstruction.config.name : "";
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], DialogHost.prototype, "key", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], DialogHost.prototype, "bottom", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], DialogHost.prototype, "height", void 0);
    DialogHost = __decorate([
        autoinject,
        __metadata("design:paramtypes", [BindingSignaler,
            DialogClientService,
            Router,
            TokenClient])
    ], DialogHost);
    return DialogHost;
}());
export { DialogHost };
var DialogItem = /** @class */ (function () {
    function DialogItem(view, model, onElementSet, fullscreen, hideOnOutsideClick) {
        this.view = view;
        this.model = model;
        this.onElementSet = onElementSet;
        this.fullscreen = fullscreen;
        this.hideOnOutsideClick = hideOnOutsideClick;
    }
    Object.defineProperty(DialogItem.prototype, "element", {
        get: function () {
            return this._element;
        },
        set: function (value) {
            this._element = value;
            if (value) {
                this.onElementSet(value);
            }
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        computedFrom('_element'),
        __metadata("design:type", Element),
        __metadata("design:paramtypes", [Element])
    ], DialogItem.prototype, "element", null);
    return DialogItem;
}());
export { DialogItem };
